module.exports = __webpack_public_path__ + "static/media/sketch.9a17c9dd.jpg";